import React from "react";
import { Link } from "react-router-dom";
import Login from "./pages/Login";
import logo from "/Users/michaeltucker/Documents/coding-projects/client/src/assets/img/square-logo-with-text-v2.png";

function LogInView() {
  return (
    <div className="auth-login-page">
      <div className="auth-login-brand">
        <Link to="/" className="auth-login-brand-link">
          <img
            src={logo}
            alt="Lesson Launchpad"
            className="auth-login-brand-logo"
          />
        </Link>
      </div>
      <div className="auth-login-panel">
        <div className="auth-login-panel-inner">
          <Login />
        </div>
      </div>
    </div>
  );
}

export default LogInView;
